export default "/images/4a993e667675142ed0072f4b7aab485f.avif";